/// Feature switches for the web app.
///
/// These are ENV-driven (`VITE_*`) on purpose: unlike the constants elsewhere in
/// shared/config, a switch here is meant to differ BETWEEN ENVIRONMENTS — off in
/// production while it stays on in a dev/staging build, without a code change.

/**
 * Web push (FCM) on the admin site — My Page's "Push notifications" card, the
 * silent token re-registration on login/reload, and the generated
 * `firebase-messaging-sw.js` service worker.
 *
 * DEFAULT: OFF. The web app is admin-only (Super Admin / Corp Admin) and alerts
 * are delivered to the mobile app, which is where the people who act on them are.
 * The feature is switched off rather than deleted so it can be turned back on
 * without rebuilding it — set `VITE_ENABLE_WEB_PUSH=true`.
 *
 * Exactly the string 'true' enables it: an unset, empty, or typo'd value must
 * fall back to OFF, never silently on.
 */
export const WEB_PUSH_ENABLED = import.meta.env.VITE_ENABLE_WEB_PUSH === 'true'
